const prefix='redgaady-driver-wallet-pending-v1:';
export const driverWalletAccount=user=>{
 const id=user?.id??user?.driverId??user?.userId;
 if(id===undefined||id===null||!String(id).trim())throw new Error('Sign in again before adding money.');
 return String(id);
};
export function readPendingDriverTopUp(account){
 if(typeof window==='undefined')return null;
 const raw=window.localStorage.getItem(prefix+encodeURIComponent(account));if(!raw)return null;
 const item=JSON.parse(raw);if(item.account!==account||item.type!=='DRIVER_WALLET_TOP_UP')throw new Error('Unable to restore this wallet operation. Check the original payment before paying again.');
 return item;
}
export function savePendingDriverTopUp(item){window.localStorage.setItem(prefix+encodeURIComponent(item.account),JSON.stringify(item));return item;}
export function clearPendingDriverTopUp(account){window.localStorage.removeItem(prefix+encodeURIComponent(account));}
export async function driverWalletLock(account,callback){
 if(typeof navigator!=='undefined'&&navigator.locks?.request)return navigator.locks.request(prefix+encodeURIComponent(account),{ifAvailable:true},lock=>{if(!lock)throw new Error('This wallet payment is open in another tab.');return callback();});
 return callback();
}
